<script setup lang="ts">
import { usePlayer } from '@/composables/game/player'

const { canUseRefillBooster, useRefillBooster, nextRefillBoosterAvailableIn, player } = usePlayer()
</script>

<template>
  <div>
    Available: {{ player.refillBooster.available }}/{{ player.refillBooster.max }} <br>
    Next available {{ nextRefillBoosterAvailableIn ? `in ${nextRefillBoosterAvailableIn} seconds` : 'now' }}
    <button
      :disabled="!canUseRefillBooster"
      @click="useRefillBooster"
    >
      Refill your energy
    </button>
  </div>
</template>

<style scoped>

</style>
